module.exports = {
  MANDATORY: "M",
  OPTIONAL: "Y",
  NEEDLESS: "N",
};
